import { Expose } from 'class-transformer';
import { CustomerValidationStatus } from '../enums/user-validate-status.enum';

export class CustomerDataUserValidate {
  @Expose() username!: string;
  @Expose() password!: string;
  @Expose() prgref!: string;
  @Expose() buchungskreis!: string;
  @Expose() device_id!: string;
  @Expose() customerId!: number;
  @Expose() createdAt!: Date;
  @Expose() updatedAt!: Date;
  @Expose() lastIdispoStatus!: CustomerValidationStatus;
  @Expose() lastUpdatedIdispo!: Date;
}

export class CustomerUserValidate {
  @Expose() customerId!: number;
  @Expose() username!: string;
  @Expose() status!: CustomerValidationStatus;
  @Expose() timestamp!: string;
  @Expose() error!: string;
  @Expose() lastShipmentAt!: Date;

  @Expose()
  customerData!: CustomerDataUserValidate;
}

export class CustomerValidationResult {
  @Expose()
  results!: CustomerUserValidate[];

  @Expose() totalProcessed!: number;
  @Expose() successCount!: number;
  @Expose() failureCount!: number;
  @Expose() processedAt!: Date;
}
